import { render, staticRenderFns } from "./NetworkPromotion.vue?vue&type=template&id=1faa78a4&scoped=true&"
import script from "./NetworkPromotion.vue?vue&type=script&lang=js&"
export * from "./NetworkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./NetworkPromotion.vue?vue&type=style&index=0&id=1faa78a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa78a4",
  null
  
)

export default component.exports